import { Dropdown } from "primereact/dropdown";
import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Link, useLocation } from "react-router-dom";
import NewSMS from "../Assets/NewSMS.svg";
import NewSMSSelected from "../Assets/NewSMSSelected.svg";
import OnGoingSMS from "../Assets/OnGoingSMS.svg";
import OnGoingSMSSelected from "../Assets/OnGoingSMSSelected.svg";
import People from "../Assets/user.png";
import ResolvedSMS from "../Assets/ResolvedSMS.svg";
import ResolvedSMSselected from "../Assets/ResolvedSMSselected.svg";
import SMS from "../Assets/SMS.svg";
import SMSnot from "../Assets/SMSnot.svg";
import {
  formatDateStringdot,
  handleError,
  handleSuccess,
} from "../CommonJquery/CommonJquery.js";
import {
  open_ticket,
  resolve_ticket,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import CreateNewTicket from "./CreateNewTicket.js";
import "./CSS/HelpSupport.css";
import ReplyToTicket from "./ReplyToTicket.js";
import Loader from "../pages/Loader.js";

function Help() {
  const location = useLocation();
  let { create, tkt_id } = location.state || {};
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [ticketTabs, setTicketTabs] = useState("Tickets");
  const [searchTicket, setSearchTicket] = useState("");
  const [TicketId, setTicketId] = useState(0);
  const [ticketList, setTicketList] = useState([]);
  const priority = [
    { name: "New Ticket", code: "New", color: "#3B8AFF" },
    { name: "On-Going", code: "On", color: "#FAC885" },
    { name: "Resolved", code: "Resolved", color: "#54C104" },
  ];

  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (create !== undefined) {
      setTicketTabs(create);
      setTicketId(tkt_id);
    }
  }, [create, tkt_id]);

  const handleTabChange = (tabName, id) => {
    setTicketId(id);
    setTicketTabs(tabName);
  };

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    await server_post_data(open_ticket, null)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          // Add expanded and displayLength properties to each ticket
          const ticketsWithExpanded = final_data.get_ticket.map((ticket) => ({
            ...ticket,
            expanded: false,
          }));
          setTicketList(ticketsWithExpanded);
          console.log(ticketsWithExpanded);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };
  useEffect(() => {
    master_data_get();
  }, []);

  //////////////////////////
  const customItemTemplate = (option) => {
    return (
      <div className="optionDIvPrio">
        <div
          className="optionBgDiv"
          style={{ backgroundColor: `${option.color}` }}
        ></div>
        {option.name}
      </div>
    );
  };
  const toggleReadMore = (ticketId) => {
    setTicketList((prevTickets) =>
      prevTickets.map((ticket) => {
        if (ticket.ticket_id === ticketId) {
          return {
            ...ticket,
            expanded: !ticket.expanded,
          };
        }
        return ticket;
      }),
    );
  };

  const [selectedTicketNumber, setSelectedTicketNumber] = useState("");

  const show_confirmation_modal = (ticket_no) => {
    setShowModal(true);
    setSelectedTicketNumber(ticket_no);
  };

  const [selectedTab, setSelectedTab] = useState("allTickets");
  const [selectedPriority, setSelectedPriority] = useState(null);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  const handlePriorityChange = (selectedPriority) => {
    setSelectedPriority(selectedPriority ? selectedPriority.code : null);

    // Update selectedTab based on selectedPriority
    if (selectedPriority) {
      const tabForPriority = mapPriorityToTab(selectedPriority.code);
      setSelectedTab(tabForPriority);
    }
  };

  const mapPriorityToTab = (priorityCode) => {
    if (priorityCode === "New") {
      return "new";
    } else if (priorityCode === "On") {
      return "onGoing";
    } else if (priorityCode === "Resolved") {
      return "resolved";
    }
    return "allTickets";
  };

  const filteredTickets = () => {
    let filteredList = ticketList;

    if (selectedTab === "new") {
      filteredList = filteredList.filter(
        (ticket) => ticket.ticket_category === "New",
      );
    } else if (selectedTab === "onGoing") {
      filteredList = filteredList.filter(
        (ticket) => ticket.ticket_category === "On-going",
      );
    } else if (selectedTab === "resolved") {
      filteredList = filteredList.filter(
        (ticket) => ticket.ticket_category === "Resolved",
      );
    }

    filteredList = filteredList.filter((ticket) => {
      let ticket_date = new Date(ticket.entry_date);
      const isDateInRange =
        selectedtime.startDate <= ticket_date &&
        selectedtime.endDate >= ticket_date;

      const isSenderMatch =
        searchTicket === "" ||
        ticket.cus_message.toLowerCase().includes(searchTicket.toLowerCase()) ||
        ticket.ticket_id.toLowerCase().includes(searchTicket.toLowerCase());
      return isDateInRange && isSenderMatch;
    });

    return filteredList;
  };

  const [selectedtime, setSelectedselectedtime] = useState({
    value: "All",
    startDate: new Date("2023-01-01"),
    endDate: new Date(),
  });

  const timeList = [
    { name: "All", code: 0 },
    { name: "This Week", code: 1 },
    { name: "This Month", code: 2 },
    { name: "Last Month", code: 3 },
    { name: "Last 3 Months", code: 4 },
  ];

  const handleDurationFilterChange = (timePeriod) => {
    const today = new Date();
    const thisWeekStart = new Date(today);
    thisWeekStart.setDate(today.getDate() - today.getDay());
    const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastMonthStart = new Date(
      today.getFullYear(),
      today.getMonth() - 1,
      1,
    );
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 1);
    lastMonthEnd.setDate(thisMonthStart.getDate() - 1);
    const last3MonthsStart = new Date(
      today.getFullYear(),
      today.getMonth() - 3,
      1,
    );

    const filters = [
      { value: "All", startDate: new Date("2023-01-01"), endDate: today },
      { value: "This Week", startDate: thisWeekStart, endDate: today },
      { value: "This Month", startDate: thisMonthStart, endDate: today },
      { value: "Last Month", startDate: lastMonthStart, endDate: lastMonthEnd },
      { value: "Last 3 Months", startDate: last3MonthsStart, endDate: today },
    ];

    setSelectedselectedtime(filters[timePeriod.code]);
  };

  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    setShowModal(false);
  };

  const searchTicketFromDB = async (input) => {
    setSearchTicket(input);
    filteredTickets();
  };

  const resolveTicket = async () => {
    setShowLoaderAdmin(true);
    let formdata = new FormData();
    formdata.append("close_by", "VENDOR");
    formdata.append("ticket_id", selectedTicketNumber);
    await server_post_data(resolve_ticket, formdata)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          master_data_get();
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });

    // Assuming the resolve function is working as expected
    setShowLoaderAdmin(false);
    handleSuccess("Ticket Resolved Successfully!");
    closeModal();
    // Refresh ticket list or perform other necessary actions
  };

  return (
    <>
      {ShowLoaderAdmin && <Loader />}
      {ticketTabs === "Tickets" && (
        // SCROLL FIX: "ticketsPageWrapper" (see HelpSupport.css) keeps the
        // header + tabs fixed and makes only the ticket list scroll,
        // instead of the whole page scrolling.
        <div className="Suppotr_wrapper ticketsPageWrapper">
          {/* {ShowLoaderAdmin && <Loader />} */}
          <div className="Suppotr_Header">
            <div className="searchInputHelp">
              <input
                type="text"
                placeholder="Search for ticket"
                onChange={(e) => {
                  searchTicketFromDB(e.target.value);
                }}
              />
            </div>

            <div className="Suppotr_HeaderRight">
              <div className="Suppotr_HeaderRightCont">
                <div className="guideBtn">
                  <p>Self Help Guide Resources</p>
                </div>
                <div className="Suppotr_HeaderBtns">
                  <Dropdown
                    style={{ cursor: "pointer" }}
                    value={priority.find((p) => p.code === selectedPriority)}
                    onChange={(e) => handlePriorityChange(e.value)}
                    options={priority}
                    optionLabel="name"
                    placeholder="Select Ticket Type"
                    className="priorityBtn"
                  />
                  <Dropdown
                    style={{ cursor: "pointer" }}
                    value={timeList.find((p) => p.name === selectedtime.value)}
                    onChange={(e) => handleDurationFilterChange(e.value)}
                    options={timeList}
                    optionLabel="name"
                    placeholder="Select Duration"
                    className="priorityBtn"
                  />
                  <Link onClick={() => handleTabChange("Create", 0)}>
                    <button className="newTicketBtn">
                      <p>New Ticket</p>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="ticketsTab">
            <div className="ticketsTab_container">
              <div
                className={`ticketsTab_btn ${
                  selectedTab === "allTickets" && "selectedTicketTab"
                }`}
                onClick={() => handleTabClick("allTickets")}
              >
                {selectedTab !== "allTickets" && (
                  <img src={SMSnot} alt="icon" />
                )}
                {selectedTab === "allTickets" && <img src={SMS} alt="icon" />}
                <p>All Tickets</p>
              </div>
              <div
                className={`ticketsTab_btn ${
                  selectedTab === "new" && "selectedTicketTab"
                }`}
                onClick={() => handleTabClick("new")}
              >
                {selectedTab !== "new" && <img src={NewSMS} alt="icon" />}
                {selectedTab === "new" && (
                  <img src={NewSMSSelected} alt="icon" />
                )}
                <p>New</p>
              </div>
              <div
                className={`ticketsTab_btn ${
                  selectedTab === "onGoing" && "selectedTicketTab"
                }`}
                onClick={() => handleTabClick("onGoing")}
              >
                {selectedTab !== "onGoing" && (
                  <img src={OnGoingSMS} alt="icon" />
                )}
                {selectedTab === "onGoing" && (
                  <img src={OnGoingSMSSelected} alt="icon" />
                )}
                <p>On-Going</p>
              </div>
              <div
                className={`ticketsTab_btn ${
                  selectedTab === "resolved" && "selectedTicketTab"
                }`}
                onClick={() => handleTabClick("resolved")}
              >
                {selectedTab !== "resolved" && (
                  <img src={ResolvedSMS} alt="icon" />
                )}
                {selectedTab === "resolved" && (
                  <img src={ResolvedSMSselected} alt="icon" />
                )}
                <p>Resolved</p>
              </div>
            </div>
          </div>
          <div className="ticketsCOntainer">
            <div className="ticketsWrapper">
              <div className="ticketslist">
                {filteredTickets().map((ticket, index) => (
                  <div className="ticketsListItem" key={index}>
                    <div className="ticketsListItemHead">
                      <div className="ticketsListItemHeadLeft">
                        {/* <div className={ticket.status}>{ticket.ticket_category}</div> */}
                        <p>Ticket #TCK- {ticket.ticket_id}</p>
                        {ticket.cus_prority === "High" && (
                          <div className="priorityStatusHigh">
                            <p className="highColor">High Priority</p>
                          </div>
                        )}
                        {ticket.cus_prority === "Medium" && (
                          <div className="priorityStatusMedium">
                            <p className="mediumColor">Medium Priority</p>
                          </div>
                        )}
                        {ticket.cus_prority == "Low" && (
                          <div className="priorityStatusLow">
                            <p className="lowColor">Low Priority</p>
                          </div>
                        )}
                        <div className="subject-text">
                          <p style={{ fontSize: "12px" }}>
                            {ticket.cus_subject}
                          </p>
                        </div>
                      </div>
                      <div className="ticketsListItemHeadRight">
                        <div className="ticketTime">
                          <p>
                            Posted on {formatDateStringdot(ticket.entry_date)}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="ticketDetails">
                      <div className="ticketDetailsContainer">
                        <h6>
                          {ticket.expanded
                            ? ticket.cus_message
                            : `${ticket.cus_message.slice(0, 200)}${ticket.cus_message.length > 200 ? "..." : ""}`}
                        </h6>
                        {ticket.cus_message.length > 200 && (
                          <button
                            onClick={() => toggleReadMore(ticket.ticket_id)}
                            className="read-more-btn"
                          >
                            {ticket.expanded ? "Read Less" : "Read More"}
                          </button>
                        )}
                        <p>{ticket.ticket_category}</p>
                      </div>
                    </div>
                    <div className="ticketsListItemFOOTER">
                      <div className="ticketsListItemfootLeft">
                        <div className="cutomerImg">
                          <img src={People} alt="icon" />
                        </div>
                        {/* <p>{ticket.business_name}</p> */}
                      </div>
                      <div className="ticketsListItemfootRight flexBtns align-items-center">
                        <div>
                          {ticket.ticket_category !== "Resolved" && (
                            <div
                              className="showTicketBtn"
                              onClick={() =>
                                show_confirmation_modal(ticket.ticket_id)
                              }
                            >
                              <p>Resolve Ticket</p>
                            </div>
                          )}
                        </div>
                        <div>
                          <Link
                            onClick={() =>
                              handleTabChange("Reply", ticket.ticket_id)
                            }
                          >
                            <div className="showTicketBtn">
                              <p>Open Ticket</p>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {ticketTabs === "Create" && (
        <CreateNewTicket setTicketTabs={setTicketTabs} />
      )}

      {ticketTabs === "Reply" && (
        <ReplyToTicket
          setTicketTabs={setTicketTabs}
          ticketId={TicketId}
          setTicketId={setTicketId}
        />
      )}

      {/* Modal */}
      <Modal show={showModal} onHide={closeModal} centered backdrop="static">
        <Modal.Body className="modal_body">
          <p>Are you sure you want to resolve the ticket?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn go_to_login" onClick={resolveTicket}>
            Resolve
          </div>
          <div className="btn go_to_login" onClick={closeModal}>
            Cancel
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Help;
